/**
 * @description: 时间戳转年月日
 * @param {Number} timeStamp 时间戳
 * @return {*}
 */
export const dateFormat = (timeStamp: number | string) => {
  // 兼容准确到秒和毫秒的时间戳
  let num = 0;
  if (typeof timeStamp === 'string') {
    num = parseInt(timeStamp, 10);
  } else {
    num = timeStamp;
  }
  if (num.toString().length === 10) {
    num = num * 1000;
  }

  // 返回 xxxx-xx-xx 格式
  const date = new Date(num);
  const yearStr = date.getFullYear();
  const month = date.getMonth() + 1;
  const monthStr = month < 10 ? `0${month}` : month;
  const day = date.getDate();
  const dayStr = day < 10 ? `0${day}` : day;
  return `${yearStr}-${monthStr}-${dayStr}`;
};
